import * as React from "react";
import { useEffect, useState } from "react";
import { validateLocalStorage } from "./utils/local-storage";

export type GlobalState = {
  isLocalStorageEnabled?: boolean;
};

const initialState: GlobalState = {
  isLocalStorageEnabled: validateLocalStorage(),
};

export const GlobalContext = React.createContext<GlobalState>(initialState);

export const RootContextComponent: React.FunctionComponent<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [globalState, setGlobalState] = useState(initialState);

  useEffect(() => {
    setGlobalState({
      ...globalState,
    });
  }, []);

  return (
    <GlobalContext.Provider
      value={{
        ...globalState,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
